import React from "react";
import { Link } from "react-router-dom";

const PasswordSuccess = () => {

  return (
    <div className="flex flex-wrap flex-col justify-center px-1  h-svh md:px-32">
      <img className="h-20 w-20" src="./img/checkbox-object.png" alt="" />
      <div className="mt-2 text-3xl font-bold">
        Password Updated
        <br />
        Successfully
      </div>

      <Link to="/" className="mt-9  border-2 border-primary  flex justify-center items-center w-full bg-white py-3 font-semibold text-sm rounded-md text-primary">
        Done
      </Link>
    </div>
  );
};

export default PasswordSuccess;
